module.exports = __webpack_public_path__ + "templates-icon.png?c9c5f130e57f801565d2ec0a4340e5c3";